import { z } from 'zod'
import { LLM_PROVIDER_VALUES, type LLMProviderValue } from './llm-api-key'

export type { LLMProviderValue }

/**
 * Phase 4 plan 04-04: frontend contracts for the `/api/v1/llm-models` catalog endpoint.
 *
 * Mirrors `backend/app/schemas/llm_models.py` shape returned by plan 04-03.
 * Capability constants mirror `MODEL_CAPABILITIES` values in
 * `backend/app/services/llm_client.py` (plan 04-01).
 */

export const modelCatalogEntrySchema = z.object({
  id: z.string(),
  display_name: z.string(),
  input_cost_per_million: z.number().nonnegative(),
  output_cost_per_million: z.number().nonnegative(),
  capabilities: z.array(z.string()),
})

export const llmModelsCatalogResponseSchema = z.object({
  provider: z.enum(LLM_PROVIDER_VALUES),
  models: z.array(modelCatalogEntrySchema),
})

export type ModelCatalogEntry = z.infer<typeof modelCatalogEntrySchema>
export type LLMModelsCatalogResponse = z.infer<
  typeof llmModelsCatalogResponseSchema
>

// Capability string constants — match backend MODEL_CAPABILITIES values.
// Kept as explicit exports so UI conditional rendering references a single
// source of truth (plan 04-04 §Capability mapping, RESEARCH §2).
export const CAP_THINKING_ADAPTIVE = 'thinking_adaptive'
export const CAP_THINKING_MANUAL = 'thinking_manual'
export const CAP_REASONING = 'reasoning'
export const CAP_REASONING_MINIMAL = 'reasoning_minimal'
export const CAP_REASONING_NONE = 'reasoning_none'
export const CAP_SAFETY_SETTINGS = 'safety_settings'
export const CAP_TOOLS = 'tools'
